export var BLUE_MAGNETA = '#383757';
export var GAINSBORO = '#DFDFDF';
export var GHOST_WHITE = '#F7F7F9';
export var NEON_BLUE = '#3447F7';
export var COMET = '#626374';
export var DARK_GRAY = '#A8A8A8';
export var PORT_GORE = '#3A406C';
export var ROCK_BLUE = '#929BAC';
export var SHAMROCK = '#4BD1A0';
export var WHITE_SMOKE = '#F1F1F1';
export var ERROR = '#E3342F';
export var MEDIUM_PURPLE = '#885AE4';
export var MINT_CREAM = '#E7FFF6';
export var JAVA = '#258C91';
export var ARSENIC = '#30404F';
export var DOLPHIN = '#727080';
export var LOGAN_LIGHT = '#A0A3BD';
export var TUTU = '#FFE9E9';
export var GREY_CHATEAU = '#919DA8';
export var WHITE_ICE = '#DDE2E0';
export var AMBER = '#FFBE0F';
export var ALICE_BLUE = '#F7F8FA';
export var MIDNIGHT_EXPRESS = '#071048';
export var NEON_BLUE_LIGHT = '#635DF6';
export var ECHO_BLUE = '#99ABCE';
export var SLATE_GREY = '#798189';
export var PERIWINKLE = '#CBD3E2';
export var FLORAL_WHITE = '#F9F7F4';
export var LINK_WATER = '#BEC3CD';
export var PURPLE_BUTTON_DISABLED = '#C1BEFB';
export var BACKGROUND_WHITE = '#F9F9FB';
export var YELLOW_SEA = '#F29D39';
export var ORANGE = '#FF981F';
export var ALIZARIN = '#F42829';
export var WARM_RED = '#FF3F3F';
export var SLATE_BLUE = '#5751CD';
export var NEON_BLUE_DARK = '#514BDF';
export var ERROR_LIGHT = '#FF5656';
export var RAVEN = '#666D78';
export var HAWKES_BLUE = '#D0D9E7';
export var SOLITUDE = '#E8EAEE';
export var GRAYISH_BLUE = '#A7B4C8';
export var PURE_RED = '#E42000';
export var CRUISE = '#B8E9D7';
export var CHABLIS = '#F5F4FF';
export var QUICK_SILVER = '#A5A5A5';
export var HONEYDEW = '#D8F0E4';
export var GAINSBORO_LIGHT = '#DADADA';
export var WHISPER = '#EDEDED';
export var YELLOW_FLORAL_WHITE = '#F7F5F2';
export var WHISPER_LIGHT = '#E5E5E5';
export var GREY = '#F2F2F2';
export var LAVANDER = '#E0DFFD';
export var MAINLY_BLUE = '#EFEFFE';
export var OFF_GREEN = '#E4F8F0';
export var ALABASTER = '#F9F9F9';
export var AZURE = '#EDF5F5';
export var LIGHT_CYAN = '#DDFEF2';
export var BURNT_SIENNA = '#E57D61';
export var DOVE_GRAY = '#6D6D6D';
export var ZAMBEZI = '#5C5C5C';
export var SILVER = '#C6C6C6';
export var BLUMINE = '#256078';
export var OREGANO_GREEN = '#40A33F';
export var SONIC_SILVER = '#757575';
export var VAMPIRE_BLACK = '#060606';
export var DARK_SLATE_BLUE = '#484581';
export var LIGHT_SILVER = '#CCE2D8';
export var CANDIED_SNOW = '#DCFFF2';
export var TITAN_WHITE = '#EEEDFF';
export var GRAY = '#808080';
export var GOLD = '#FFCC33';
export var RAISIN_BLACK = '#222222';
export var BRIGHT_GRAY = '#EFEFEF';
export var ROBO_MASTER = '#ADADAD';
export var OLD_SILVER = '#828282';
export var BLACK = '#000000';
export var WHITE = '#FFFFFF';
export var LIGHT_BLACK = '#141415';
export var DISABLED_ITEM = '#D9D9D9';
export var DIRTY_WHITE = '#F6F6F6';
export var CADMIUM_RED = '#EB001B';
export var DIM_GRAY = '#666666';
export var ISLAND = '#AEAEAE';
export var ORANGINA = '#FC4C15';
export var ALIZARIN_CRIMSON = '#E53238';
export var SHARP_YELLOW = '#EEC343';
export var PERSIMMON = '#F45800';
export var MEDIUM_GRAY = '#9E9E9E';
export var AQUA_GREEN = '#4CCBB1';
export var SNOW_WHITE = '#FAFAFA';
export var GAINSBORO_BORDER = '#E0E0E0';
export var EERIE_BLACK = '#212121';
export var BUBBLES = '#EDFFFE';
export var SILVER_SAND = '#BDBDBD';
export var LIGHT_GRAY = '#F5F5F5';
export var SIDEBAR_SILVER = '#C0C0C0';
export var GUNMETAL = '#35383F';
export var VIVID_BLUE = '#246BFD';
export var CHARCOAL = '#424242';
export var DEEP_ORANGE = '#FF5726';
export var DEEP_ORANGE_LIGHT = '#FF7043';
//# sourceMappingURL=colors.js.map